import React from "react";
import {UseFormReturn} from "react-hook-form";
import {CreateAndEditSubscriptionProps, CreateAndEditSubscriptionState} from "./models";
import {withUseFormHook} from "@sinossi/mates-react-library";
import * as Yup from "yup";
import {
    Box,
    Button,
    Fab,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import {t, Trans} from "@lingui/macro";
import AddIcon from "@mui/icons-material/Add";
import ErrorIcon from "@mui/icons-material/Error";
import ClearIcon from '@mui/icons-material/Clear';
import CircleIcon from "@mui/icons-material/Circle";
import { CreateSubscriptionRequest } from "models/request";
import { Subscription, SubscriptionFeature } from "models";
import { ZPlayFormField } from "commons/fields";
import ZplayFormField from "commons/fields/zplay-form-field";


const CreateAndEditSubscriptionFormSchema = Yup.object().shape({
});

class CreateAndEditSubscription extends React.Component<CreateAndEditSubscriptionProps & UseFormReturn, CreateAndEditSubscriptionState> {

    constructor(props: any) {
        super(props);

        this.state={
            formFlag: false,
            features: [],
            featureError: false
        }
    }

    componentDidMount() {
        if(this.props.subscription){
            this.setFormValues();
        }

        this.setState(() => ({formFlag: true}));
    }

    private setFormValues(){
        this.props.setValue('name', this.props.subscription!.name)
        this.props.setValue('monthlyPriceWithoutVAT', this.props.subscription!.monthlyPriceWithoutVAT/100)
        this.props.setValue('yearlyPriceWithoutVAT', this.props.subscription!.yearlyPriceWithoutVAT/100)
        this.setState(() => ({
            features: this.props.subscription!.features,
        }));
    }

    private submitForm = (values: any) => {

        if(!this.props.subscription){
            let request: CreateSubscriptionRequest = {
                name: values.name,
                monthlyPriceWithoutVAT: Number(values.monthlyPriceWithoutVAT) ? Math.trunc(Number(values.monthlyPriceWithoutVAT)*100) : -1,
                yearlyPriceWithoutVAT:  Number(values.yearlyPriceWithoutVAT) ? Math.trunc(Number(values.yearlyPriceWithoutVAT)*100) : -1,
                VATPercentage: Number(values.VATPercentage) ? Number(values.VATPercentage) : -1,
                features: this.state.features
            }

            this.props.onSubmit(request);
        }else{
            let request: Subscription = this.props.subscription
            request.name = values.name
            request.monthlyPriceWithoutVAT = Number(values.monthlyPriceWithoutVAT) ? Math.trunc(Number(values.monthlyPriceWithoutVAT)*100) : -1
            request.yearlyPriceWithoutVAT = Number(values.yearlyPriceWithoutVAT) ? Math.trunc(Number(values.yearlyPriceWithoutVAT)*100) : -1
            request.VATPercentage = Number(values.VATPercentage) ? Number(values.VATPercentage) : -1
            request.features = this.state.features

            this.props.onSubmit(request);
        }
    };

    private addFeature = (): void => {

        this.setState(() => ({
            featureError: false,
        }));

        let feature: SubscriptionFeature = {
            key:this.props.getValues("key"),
            value:this.props.getValues("value")
        }

        if (!feature.key || !feature.value){
            this.setState(() => ({
                featureError: true,
            }));
            return
        }

        this.setState(prevState => ({
            features: [...prevState.features, feature]
        }));

        this.props.setValue("key", "");
        this.props.setValue("value", "")
    }

    private deleteFeature = (feature: SubscriptionFeature) => {

        this.setState(prevState => ({
            features: prevState.features.filter(item => (item.key !== feature.key && item.value !== feature.value))
        }));
    }

    render() {
        return (
            <Box>
                {this.state.formFlag && <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <Box
                        p={3}
                        borderRadius="5px"
                        bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                        <Grid container columnSpacing={3} rowSpacing={1} mb={1}>
                            {/* **************** NAME  **************** */}
                            <Grid item xs={12} md={12}>
                                <ZplayFormField
                                    label={t({
                                        id: "caes-name",
                                        message: "Nome"
                                    })}
                                    name={'name'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            {/* **************** PRICES AND VAT**************** */}
                            <Grid item xs={12} md={6}>
                                <ZPlayFormField
                                    label={t({
                                        id: "caes-monthly-price",
                                        message: "Prezzo Mensile"
                                    })}
                                    name={'monthlyPriceWithoutVAT'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <ZplayFormField
                                    label={t({
                                        id: "caes-yearly-price",
                                        message: "Prezzo Annuale"
                                    })}
                                    name={'yearlyPriceWithoutVAT'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>

                        {/* **************** FEATURES **************** */}
                        {this.state.features.length > 0 && <Grid container mt={2}>
                            <Grid item xs={12} md={6}>
                                <List dense >
                                    {this.state.features.map((feature, i) =>
                                        <ListItem
                                            key={i}
                                            secondaryAction={
                                                <IconButton edge="end" aria-label="delete" onClick={() => this.deleteFeature(feature)}>
                                                    <ClearIcon fontSize="small" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemIcon sx={{ minWidth: "35px" }}>
                                                <CircleIcon sx={{ width: "10px", height: "10px", color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Stack direction="row" spacing={5}>
                                                        <Typography
                                                            variant="caption"
                                                            maxWidth={250}
                                                            sx={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                color: process.env.REACT_APP_DEFAULT_TEXT_COLOR
                                                            }}>
                                                            {feature.key}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            maxWidth={400}
                                                            sx={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                color: process.env.REACT_APP_DEFAULT_TEXT_COLOR
                                                            }}>
                                                            {feature.value}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            />
                                        </ListItem>
                                    )}
                                </List>
                            </Grid>
                        </Grid>}

                        <Grid container columnSpacing={3} rowSpacing={1}>
                            <Grid item xs={12} md={6}>
                                <ZplayFormField
                                    label={t({
                                        id: "caes-key",
                                        message: "Feature"
                                    })}
                                    name={'key'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <ZplayFormField
                                    label={t({
                                        id: "caes-value",
                                        message: "Valore"
                                    })}
                                    name={'value'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={1} textAlign="right">
                                <Tooltip title="Aggiungi feature" placement="right" sx={{mt: 1}}>
                                    <Fab size="small" color="primary" onClick={this.addFeature}>
                                        <AddIcon />
                                    </Fab>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        {this.state.featureError && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"caes-feature-error"}>È necessario inserire il nome e il valore.</Trans>
                            </Typography>
                        </Stack>}
                    </Box>

                    <Grid item
                          xs={12}
                          mt={2}
                          textAlign={"right"}>
                        <Button
                            variant="contained"
                            color={"primary"}
                            disabled={this.props.formState.isSubmitting}
                            type="submit">
                            {this.props.subscription?
                                <Trans id="caes-submit-edit-button">Modifica</Trans> :
                                <Trans id="caes-submit-create-button">Crea</Trans>}
                        </Button>
                    </Grid>
                </form>}
            </Box>
        );
    }


}


export default withUseFormHook<{}>(CreateAndEditSubscription, CreateAndEditSubscriptionFormSchema, {});